import { render, staticRenderFns } from "./FraudPreventionMsg.vue?vue&type=template&id=3fe96e35&scoped=true"
import script from "./FraudPreventionMsg.vue?vue&type=script&lang=js"
export * from "./FraudPreventionMsg.vue?vue&type=script&lang=js"
import style0 from "./FraudPreventionMsg.vue?vue&type=style&index=0&id=3fe96e35&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fe96e35",
  null
  
)

export default component.exports